module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-fr-089cf53467aeae06eeaa27f2317bbeb1.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-fr.svg
// module id = 4uV7
// module chunks = 20 22